import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../lib/UserContext';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../css/Login.css';

function CambiarPassword() {
  const [passwordActual, setPasswordActual] = useState('');
  const [passwordNueva, setPasswordNueva] = useState('');
  const [passwordConfirmar, setPasswordConfirmar] = useState('');
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const { login } = useUser();
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const cambioData = sessionStorage.getItem('cambioPasswordData');
    if (!cambioData) {
      toast.error('No hay sesión activa');
      navigate('/ofrendas');
      return;
    }
    
    try {
      const user = JSON.parse(cambioData);
      setUserData(user);
      console.log('Usuario requiere cambio de contraseña:', user);
    } catch (error) {
      console.error('Error al parsear datos:', error);
      navigate('/ofrendas');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validaciones
    if (!passwordActual || !passwordNueva || !passwordConfirmar) {
      toast.error('Todos los campos son requeridos');
      return;
    }

    if (passwordNueva !== passwordConfirmar) {
      toast.error('Las contraseñas nuevas no coinciden');
      return;
    }

    if (passwordNueva.length < 6) {
      toast.error('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    if (passwordActual === passwordNueva) {
      toast.error('La nueva contraseña debe ser diferente a la actual');
      return;
    }

    if (!userData) {
      toast.error('Error: datos de usuario no disponibles');
      navigate('/ofrendas');
      return;
    }

    setLoading(true);

    try {
      console.log('🔐 Cambiando contraseña...');
      
      const response = await axios.post(`${apiUrl}/Donantes/cambiar-password`, {
        identificacion: userData.identificacion,
        passwordActual: passwordActual,
        passwordNueva: passwordNueva
      });

      console.log('✅ Contraseña cambiada exitosamente:', response.data);
      
      // Limpiar datos temporales
      sessionStorage.removeItem('cambioPasswordData');
      
      // Actualizar userData sin el cambioHash
      const updatedUserData = { ...userData, cambioHash: 'N' };
      
      // Establecer el usuario en el contexto
      login(updatedUserData);
      
      toast.success('Contraseña actualizada exitosamente');
      
      // Redirigir a opciones
      setTimeout(() => {
        navigate('/opciones');
      }, 1500);

    } catch (error) {
      console.error('❌ ERROR al cambiar contraseña:', {
        message: error?.message,
        status: error?.response?.status,
        data: error?.response?.data
      });
      
      if (error?.response?.status === 401) {
        toast.error('Contraseña actual incorrecta');
      } else if (error?.response?.status === 400) {
        toast.error(error.response.data?.mensaje || 'Error en los datos proporcionados');
      } else {
        toast.error('Error al cambiar contraseña. Intente nuevamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    toast.info('Debe cambiar su contraseña para continuar');
  };

  if (!userData) {
    return null;
  }

  return (
    <div className="login-container">
      <ToastContainer position="top-right" autoClose={3000} />
      
      <div className="login-card">
        <div className="login-header">
          <i className="fas fa-key login-icon"></i>
          <h1>Cambiar Contraseña</h1>
          <p>Por seguridad, debe cambiar su contraseña inicial</p>
        </div>

        <div className="user-info" style={{
          backgroundColor: '#fff3cd',
          padding: '1rem',
          borderRadius: '8px',
          marginBottom: '1.5rem',
          border: '1px solid #ffc107',
          color: '#856404'
        }}>
          <p style={{ margin: '0.5rem 0' }}>
            <i className="fas fa-exclamation-triangle"></i>{' '}
            <strong>Usuario:</strong> {userData.nombres} {userData.apellidos}
          </p>
          <p style={{ margin: '0.5rem 0', fontSize: '0.9rem' }}>
            Su contraseña actual es su número de identificación.
          </p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="passwordActual">
              <i className="fas fa-lock"></i> Contraseña Actual
            </label>
            <input
              type="password"
              id="passwordActual"
              value={passwordActual}
              onChange={(e) => setPasswordActual(e.target.value)}
              placeholder="Ingrese su contraseña actual"
              required
              autoFocus
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="passwordNueva">
              <i className="fas fa-key"></i> Nueva Contraseña
            </label>
            <input
              type="password"
              id="passwordNueva"
              value={passwordNueva}
              onChange={(e) => setPasswordNueva(e.target.value)}
              placeholder="Ingrese su nueva contraseña (mínimo 6 caracteres)"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="passwordConfirmar">
              <i className="fas fa-check-circle"></i> Confirmar Nueva Contraseña
            </label>
            <input
              type="password"
              id="passwordConfirmar"
              value={passwordConfirmar}
              onChange={(e) => setPasswordConfirmar(e.target.value)}
              placeholder="Confirme su nueva contraseña"
              required
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            className="btn-login"
            disabled={loading}
            style={{ marginTop: '1.5rem' }}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Actualizando...
              </>
            ) : (
              <>
                <i className="fas fa-save"></i> Cambiar Contraseña
              </>
            )}
          </button>
        </form>

        <div className="login-footer">
          <p style={{ color: '#dc3545', fontWeight: '500' }}>
            <i className="fas fa-info-circle"></i> Debe cambiar su contraseña para acceder al sistema
          </p>
        </div>
      </div>
    </div>
  );
}

export default CambiarPassword;
